export const getTokenFromTheme = (theme, tokenName) => {
  return theme.tokenMap.get(tokenName);
};